import React from 'react';
import { Card, Spin } from 'antd';

const LoadingCard = ({
    size = "large",
    padding = '1rem',
    message = null,
    height = null,
    style = {},
    ...cardProps
}) => {
    const cardStyle = {
        ...style,
        ...(height && { height })
    };

    const bodyStyle = {
        padding,
        ...(height && { height: '100%' })
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '3.7rem',
        ...(height && { height: '100%' })
    };

    return (
        <Card
            styles={{ body: bodyStyle }}
            style={cardStyle}
            {...cardProps}
        >
            <div style={containerStyle}>
                <Spin size={size} />
                {message && (
                    <div style={{ marginTop: '1rem', color: '#666' }}>
                        {message}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default LoadingCard; 